// Sorting options for customers
const sortOptions = [
   { value: "recent", label: "Latest Customers" },
  { value: "oldest", label: "Oldest Customers" },
 
  
];

module.exports = { sortOptions };
